const titleHeaderEvent = {
  text: 'Día'
};

export default titleHeaderEvent;
